/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import axios from 'axios';
import * as serviceEndPoint from '../../../../SharedModules/services/service';
import _ from 'lodash';
import * as ActionTypes from './ActionTypes';
import { NO_DATA } from '../../../../SharedModules/Errors/constantMessageData';

// dispatch function for tab data for request screen
export const familyPlanningDrugsInvSearchObj = (data) => ({
  type: ActionTypes.GET_FAMILY_PLANNING_DRUGS_INV_SEARCH_OBJ,
  screenData: data,
});
// dispatch Display screen Object
export const dispatchDisplayFamilyInv = (data) => ({
  type: ActionTypes.SET_DISPLAY_OBJ_FAMILY_INV,
  payload: data,
});
//loading tHE api data
export const setLoading = (value) => ({
  type: ActionTypes.IS_LOADING,
  isLoading: value,
});
// plan Type dispatch
export const dispatchPlanType = (data) => ({
  type: ActionTypes.GET_PLAN_TYPE_DATA,
  payload: data,
});

// To get plantype data
export const getPlanTypeValues = () => (dispatch) => {
  return axios
    .post(serviceEndPoint.GET_COMMON_MANUFACUTRE_DROPDOWNS, {
      codeDomainList: ['PLAN_TYPE_CD'],
    })
    .then((response) => {
      return dispatch(dispatchPlanType(response.data));
    })
    .catch((response) => {
      dispatch(dispatchPlanType([]));
    });
};

// rebate programe dispatch function
export const setRebatePrograme = (data) => ({
  type: ActionTypes.SET_REBATE_PROGRAM,
  payload: data,
});

// rebate programe dispatch function
// export const dispatchRebatePrograme = (data) => ({
//   type: ActionTypes.GET_REBATE_PROGRAM,
//   payload: data,
// });

//  get rebate programe funnction
export const getRebateProgrameList = (value) => (dispatch) => {
  return axios
    .post(`${serviceEndPoint.SYSTEM_LIST_ALL_DROPDOWN}`, { planType: value })
    .then((response) => {
      return response.data;
    })
    .catch((response) => {});
};

//  error msg dispatch function
export const dispatchErrorMsgFamilyPlanningDrugsInv = (data) => ({
  type: ActionTypes.GET_ERROR_MSG_FAMILY_PLANNING_DRUGS_INV,
  payload: data,
});

//Refresh Functinality
export const refreshFamilyPlanningDrugInv = () => ({
  type: ActionTypes.REFRESH_FAMILY_PLANNING_DRUGS_INV,
  payload: {},
});

export const refreshFamilyPlanningDrugInvDisplay = () => ({
  type: ActionTypes.REFRESH_FAMILY_PLANNING_DRUGS_INV_DISPLAY,
  payload: {},
});

//dispatch display screen feild

export const dispatchQtrValue = (data) => ({
  type: ActionTypes.DISPATCH_QTR_VALUE,
  payload: data,
});

// This action show error message for 5 sec for no contract exists
const showNoDataMessage = () => (dispatch) => {
  // setTimeout(() => {
  // dispatch(dispatchErrorMsgFamilyPlanningDrugsInv([]));
  // }, 5000);
  dispatch(
    dispatchErrorMsgFamilyPlanningDrugsInv([
      {
        field: 'noData',
        message: NO_DATA,
      },
    ])
  );
};

//dispatch API
export const dispatchFamilyPlanningDrugsInvData = (data) => ({
  type: ActionTypes.SET_FAMILY_PLANNING_DRUGS_INV_DETAIL,
  payload: data,
});

//get manufacturer list
export const getFamilyPlanningDrugsInvData = (values) => (dispatch) => {
  dispatch(setLoading(true));
  dispatch(dispatchFamilyPlanningDrugsInvData([]));
  return axios
    .post(serviceEndPoint.GET_FAMILY_PLANNING_DRUGS_INV_DETAIL, values)
    .then((response) => {
      dispatch(setLoading(false));
      if (response?.data?.familiyPlanningDrugInvoicedVO.length === 0) {
        dispatch(showNoDataMessage());
      } else {
        dispatch(
          dispatchFamilyPlanningDrugsInvData(
            response?.data?.familiyPlanningDrugInvoicedVO
          )
        );
      }
    })
    .catch((response) => {
      dispatch(setLoading(false));
      dispatch(dispatchFamilyPlanningDrugsInvData([]));
    });
};
